/**
 * Product page: clicking the star rating next to the product title scrolls
 * to the Judge.me reviews widget lower on the page.
 * The rating is rendered as <a href="#judgeme_product_reviews" data-reviews-link>
 * in sections/product-oja.liquid, so it still works as a plain anchor without
 * this script; the script adds smooth scrolling and a sticky-header offset.
 */
(function () {
  var TARGET_ID = 'judgeme_product_reviews';

  function headerOffset() {
    var candidates = document.querySelectorAll('header-component, header, [role="banner"], .shopify-section-header');
    for (var i = 0; i < candidates.length; i++) {
      var position = window.getComputedStyle(candidates[i]).position;
      if (position === 'sticky' || position === 'fixed') {
        return Math.max(0, Math.min(Math.round(candidates[i].getBoundingClientRect().bottom), 160));
      }
    }
    return 0;
  }

  function initRatingLink(root) {
    if (root.dataset.ojaRatingInit === 'true') return;

    var link = root.querySelector('[data-reviews-link]');
    if (!link) return;
    root.dataset.ojaRatingInit = 'true';

    link.addEventListener('click', function (event) {
      event.preventDefault();

      var target = document.getElementById(TARGET_ID);
      if (!target) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      target.style.scrollMarginTop = headerOffset() + 16 + 'px';
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  document.querySelectorAll('[data-product-page]').forEach(initRatingLink);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-page]');
    if (root) initRatingLink(root);
  });
})();